import React from 'react';
import styled from 'styled-components';
import { DismissDialogIcon } from 'assets/svgs';

function StairSubFiltersDialog({ handleStairSubFiltersDialog, children }) {
  return (
    <Container>
      <DismissDialog onClick={() => handleStairSubFiltersDialog({ animation: 'dismiss' })}>
        <DismissDialogIcon />
      </DismissDialog>
      {children}
    </Container>
  );
}

const Container = styled.div`
  align-items: center;
  background-color: #f1f1f1;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  padding: 50px;
  width: 260px;

  button {
    border-radius: 100px;
    font-size: 0.875rem;
    height: 40px;
    text-transform: capitalize;
    white-space: nowrap;
  }
`;

const DismissDialog = styled.div`
  align-items: center;
  background-color: var(--connolly-black);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 34px;
  justify-content: center;
  padding: 8px 11px;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
`;

export default StairSubFiltersDialog;
